import { ChevronDown as CarbonChevronDown } from '@carbon/react/icons';
import { iconPropTypes, iconDefaultProps } from '../../types/prop-types/icons';

const getChevronDownIcon = (size = 16) => {
  const ChevronDownIcon = (props) => (
    <CarbonChevronDown size={size} {...props} />
  );

  ChevronDownIcon.propTypes = iconPropTypes;
  ChevronDownIcon.defaultProps = iconDefaultProps;

  return ChevronDownIcon;
};

export const ChevronDown16 = getChevronDownIcon();
export const ChevronDown20 = getChevronDownIcon(20);
export const ChevronDown24 = getChevronDownIcon(24);
export const ChevronDown32 = getChevronDownIcon(32);
